import React from 'react';
import ProductCard from './ProductCard';
import { ArrowRight } from 'lucide-react';

const ProductGrid = ({ title, products, onAddToCart, onWishlist, onQuickView, limit, onViewAll, compact = false }) => {
  const displayProducts = limit ? products.slice(0, limit) : products;

  return (
    <section className={compact ? 'py-6' : 'py-10'}>
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
              {title}
            </h2>
            <div className="mt-1.5 w-16 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-full" />
          </div>
          {onViewAll && (
            <button
              onClick={onViewAll}
              className="flex items-center gap-1.5 text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors group"
              data-testid={`view-all-${title?.toLowerCase().replace(/\s+/g, '-')}`}
            >
              View All
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </button>
          )}
        </div>

        {/* Product Grid */}
        <div className={`grid gap-3 sm:gap-4 ${
          compact
            ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6'
            : 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'
        }`}>
          {displayProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={onAddToCart}
              onWishlist={onWishlist}
              onQuickView={onQuickView}
              compact={compact}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
